import React from 'react';
import {commonJump} from 'utils/utils';
import {inject, observer} from 'mobx-react';
import {IMG_PATH} from '../../constant';
import Layout from '../Layout';

import './index.scss';

@inject('store')
@observer
class ActivityNew extends React.Component {
    render() {
        const {hdzxbq: data = []} = this.props.store.renderData;
        if (!data.length) {
            return null;
        }
        return (
            <Layout
                id="hdzxbq"
                className="m-activity"
                titImg={`${IMG_PATH}/activity.png`}
                displayLimit={3}
                moduleName="hdzx"
                tabData={data}
                eidSuffix="zixun"
                renderList={({list, tabName}) => {
                    return (
                        <div className="m-activity-content">
                            {
                                list.map((v, k) => {
                                    const {title, img, jumpInfo} = v;
                                    return <div className="ma-item g-flexbox-start" data-sk-eid="list_zixun" data-sk-edata={JSON.stringify({url: jumpInfo, tabName})} key={k} onClick={() => {
                                        commonJump(jumpInfo);
                                    }}>
                                        <div className="title">{title}</div>
                                        <img className="img" src={img.touch}></img>
                                    </div>;
                                })
                            }
                        </div>
                    );
                }}
            />
        );
    }
}

export default ActivityNew;